"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModal = exports.Modal = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const I18n_1 = require("../../i18n/I18n");
function Modal(_a) {
    var { title, children, onHide, show } = _a, modalProps = tslib_1.__rest(_a, ["title", "children", "onHide", "show"]);
    const { t } = I18n_1.useTranslation();
    const handleOnClose = () => {
        onHide && onHide();
    };
    return (jsx_runtime_1.jsxs("div", Object.assign({}, modalProps, { hidden: !show }, { children: [jsx_runtime_1.jsxs("div", { children: [jsx_runtime_1.jsx("div", { children: title }, void 0),
                    jsx_runtime_1.jsx("button", Object.assign({ onClick: handleOnClose }, { children: t("Close") }), void 0)] }, void 0), children] }), void 0));
}
exports.Modal = Modal;
function useModal(_a) {
    var { Component, show, onHide } = _a, props = tslib_1.__rest(_a, ["Component", "show", "onHide"]);
    const [showState, setShow] = react_1.useState(show);
    const openModal = () => setShow(true);
    const closeModal = () => setShow(false);
    const handleOnHide = () => {
        closeModal();
        onHide && onHide();
    };
    const ModalComponent = Component || Modal;
    return {
        modal: jsx_runtime_1.jsx(ModalComponent, Object.assign({}, props, { show: showState, onHide: handleOnHide }), void 0),
        openModal,
        closeModal,
    };
}
exports.useModal = useModal;
//# sourceMappingURL=Modal.js.map